import { Icon, IconProps, SkeletonLoader, Typography, XStack, YStack } from '@shinetools/lumen-react'
import { FC, PropsWithChildren, ReactElement } from 'react'

interface SettingInputProps extends PropsWithChildren {
  label?: string
  description?: string | ReactElement
  isLoading?: boolean
  icon?: IconProps['icon']
}

const ContextualSettingsInputIcon: FC<Pick<SettingInputProps, 'isLoading' | 'icon'>> = ({ isLoading, icon }) => {
  if (isLoading) {
    return <SkeletonLoader shape="circle" size="small" />
  }

  if (icon) {
    return <Icon icon={icon} />
  }

  return null
}

export const ContextualSettingInput: FC<SettingInputProps> = ({
  label,
  isLoading = false,
  description,
  icon,
  children,
}) => {
  return (
    <XStack>
      <XStack
        gap={8}
        align="center"
        style={{
          // hack to get it to match design. Not responsive
          maxWidth: '548px',
        }}
      >
        <ContextualSettingsInputIcon icon={icon} isLoading={isLoading} />
        <YStack gap={4}>
          {isLoading ? (
            <SkeletonLoader size="big" width="400px" />
          ) : (
            <Typography.Text size="medium" weight="medium">
              {label}
            </Typography.Text>
          )}
          {isLoading ? (
            <SkeletonLoader size="small" width="300px" />
          ) : (
            <Typography.Text size="small" weight="regular" color="var(--lumen-color-content-neutral-medium)">
              {description}
            </Typography.Text>
          )}
        </YStack>
      </XStack>
      {children}
    </XStack>
  )
}
